import React from 'react';

const Paragraph = ({ content }) => {
  if (typeof content === 'string') {
    return (
      <p className="body-medium text-text-secondary leading-relaxed">{content}</p>
    );
  }
  return (
    <p className="body-medium text-text-secondary leading-relaxed">
      <strong className="text-brand-primary">{content.strong}</strong>
      {content.rest}
    </p>
  );
};

export const BiografiaSection = ({ title, paragraphs }) => (
  <div className="pt-6 border-t border-border-medium">
    <h3 className="heading-4 text-brand-primary mb-4">{title}</h3>
    <div className="space-y-4">
      {paragraphs.map((content, idx) => (
        <Paragraph key={idx} content={content} />
      ))}
    </div>
  </div>
);
